import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=2c5b2a24&scoped=true&"
import script from "./AdminContainer.vue?vue&type=script&lang=js&"
export * from "./AdminContainer.vue?vue&type=script&lang=js&"
import style0 from "./AdminContainer.vue?vue&type=style&index=0&id=2c5b2a24&prod&lang=less&scoped=true&"
import style1 from "./AdminContainer.vue?vue&type=style&index=1&id=2c5b2a24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b2a24",
  null
  
)

export default component.exports